import { Header } from './Header';

export type { TypeHeaderProps } from './types';
export default Header;
